export default "__VITE_ASSET__BPFEFIf8__"